import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { AppCommonsModule } from "src/app/commons/app-commons.module";
import { PlessSharedModule } from "src/app/shared/pless-shared.module";
import { KYMW1422Component } from "./kymw1422.component";
import { GetParentChildPageService } from "./api-services/get-parent-child-page.service";
import { UpdateParentChildDivService } from "./api-services/update-parent-child-div.service";


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    WjGridModule,
    AppCommonsModule,
    PlessSharedModule,
  ],
  declarations: [KYMW1422Component],
  providers: [
    GetParentChildPageService,
    UpdateParentChildDivService
  ],
})
export class KYMW1422Module { }